export { default as PhotographSolidIcon } from './PhotographSolidIcon';
